import React from "react";

export default function LogoHorizontal({ className = "" }) {
  return (
<div className={`flex flex-col leading-tight items-center ${className}`}>      <span style={{
      fontFamily: "'Playfair Display', Georgia, serif",
      fontSize: "1.35rem",
      fontWeight: 700,
      color: "#2f502a",
      letterSpacing: "0.03em",
}}>
  Stewart's <em>Sweet</em> Shells
</span>
      <span
        style={{
          fontFamily: "'Dancing Script', cursive",
          fontSize: "1.0rem",
          color: "#6f9d68",
          letterSpacing: "0.04em",
        }}
      >
        cottage kitchen
      </span>
    </div>
  );
}